import React from 'react'
import { useTable, useGlobalFilter } from 'react-table'
import './ProductsTable.css'
import { FormatMoney } from 'Utils/functions'
import { ArrowDownUp } from 'react-bootstrap-icons'
import { t } from 'i18next'
import ToolTipAmount from 'Components/ToolTipAmount/ToolTipAmount'

function ProductsTable({ data, columns, isProductPage, hideFooter, totals }) {
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance

  return (
    <>
      <table className="table-detail-invoice-table-style" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th
                  key={i}
                  {...column.getHeaderProps({
                    style: {
                      width: column.width,
                    },
                  })}>
                  <div className="detail-invoice-header-table-container">
                    <div className="detail-invoice-header-text">
                      {column.render('Header')}
                    </div>
                    {column.arrowOrderEnabled ? (
                      <ArrowDownUp className="arrow-detail-invoice-style" />
                    ) : null}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, index) => {
            prepareRow(row)
            return (
              <tr
                key={index}
                {...row.getRowProps({
                  style:
                    rows.length <= index + 1
                      ? { borderBottom: '1px solid #E1E1E1' }
                      : { borderBottom: 'none' },
                })}>
                {row.cells.map((cell, i) => (
                  <td
                    key={i}
                    {...cell.getCellProps({
                      style: {
                        width: cell.column.width,
                        padding: '21px 2px',
                      },
                    })}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginLeft: 15,
                      }}>
                      {cell.column.Header === 'Precio total' ||
                      cell.column.Header === 'Precio unitario' ? (
                        <div className="detail-invoice-table-text">
                          {'$ ' +
                            (cell.value
                              ? FormatMoney(cell.value, true, 2)
                              : '0.00')}
                        </div>
                      ) : cell.column.Header === 'Referencia' ? (
                        <div className="detail-invoice-table-text">
                          {cell.render('Cell')}
                        </div>
                      ) : (
                        <div className="detail-invoice-table-text">
                          {cell.render('Cell')}
                        </div>
                      )}
                    </div>
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  {t('DETAIL_DOCUMENTS_T.SUB_TOTAL')}
                </div>
              </div>
            </td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  ${FormatMoney(totals?.SubTotal, true, 2)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  {t('DETAIL_DOCUMENTS_T.DISCOUNT')}
                </div>
              </div>
            </td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  ${FormatMoney(totals?.GlobalDiscount, true, 2)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  {t('DETAIL_DOCUMENTS_T.ITBMS')}
                </div>
              </div>
            </td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  <ToolTipAmount amount={totals?.Tax} />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  {t('DETAIL_DOCUMENTS_T.TOTAL')}
                </div>
              </div>
            </td>
            <td>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: 15,
                }}>
                <div className="detail-invoice-table-text">
                  <ToolTipAmount amount={totals?.GrandTotal} />
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  )
}

export default ProductsTable
